import { useEffect, useState } from "react";
import PlanSetup from "./PlanSetup";
import { useDispatch } from "react-redux";
import { ThunkDispatch } from "@reduxjs/toolkit";
import {
  clearProductionState,
  setProductionPreviousPlan,
} from "../../services/productionPlanReportSlice";
import { useLocation } from "react-router-dom";
import ProductionPlanReportDetails from "./ProductionPlanDetails";

const ProductionPlanReport = () => {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  const location = useLocation();
  const previousPlan = location?.pathname?.includes("previous");
  const [open, setOpen] = useState<boolean>(false);
  const handleClick = (): void => {
    setOpen(true);
  };

  const handleFilterChange = (): void => {
    setOpen(false);
  };

  useEffect(() => {
    dispatch(setProductionPreviousPlan(previousPlan));
    return () => {
      dispatch(clearProductionState());
    };
  }, [location?.pathname]);

  return (
    <div className="content-wrapper">
      <h1 className="flex align-items-center">
        {previousPlan ? "Previous Production Plan" : "Production Plan Report"}
      </h1>
      <PlanSetup
        handleClick={handleClick}
        handleFilterChange={handleFilterChange}
      />
      {open && <ProductionPlanReportDetails />}
    </div>
  );
};

export default ProductionPlanReport;
